import {
    AssociatedDocuments as AssociatedDocumentsType,
    BibliographicReference,
} from '@livv/models';
import { Box } from '@mui/material';
import { FC } from 'react';
import AssociatedDocuments from './AssociatedDocuments';

interface SideContentProps {
    associatedDocuments?: AssociatedDocumentsType;
    decisionYear: number;
    bibliography: BibliographicReference[];
    focusedAnalysisId?: string;
}

const SideContent: FC<SideContentProps> = ({
    associatedDocuments,
    decisionYear,
    bibliography,
    focusedAnalysisId,
}) => (
    <Box data-test-id="side-content" sx={{ '>:not(h2):not(:last-child)': { mb: 7 } }}>
        <AssociatedDocuments
            associatedDocuments={associatedDocuments}
            bibliography={bibliography}
            decisionYear={decisionYear}
            focusedAnalysisId={focusedAnalysisId}
        />
    </Box>
);

export default SideContent;
